
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApplicationActivity } from '../../../../common/models/application';
import { Guid } from 'guid-typescript';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject, takeUntil } from 'rxjs';


@Component({
    selector: 'app-activities',
    templateUrl: './activities.component.html',
    styleUrls: ['./activities.component.scss'],
    imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatIconModule,
    MatExpansionModule,
    MatTooltipModule
]
})
export class ActivitiesComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() activitiesForm?: FormGroup;

  @ViewChildren('expansionPanel', { read: MatExpansionPanel }) expansionPanels!: QueryList<MatExpansionPanel>;
  @ViewChildren('activityNameInputs') activityNameInputs!: QueryList<ElementRef<HTMLInputElement>>;

  get activitiesArray(): FormArray {
    return this.activitiesForm?.get('activities') as FormArray;
  }

  constructor(private fb: FormBuilder, private snackBar: MatSnackBar) {   
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addActivity(activity?: ApplicationActivity, autoFocus: boolean = true): void {
    const isNew = !activity || activity.id === Guid.parse(Guid.EMPTY);
    const activityId = isNew ? Guid.EMPTY.toString() : activity.id.toString();

    const activityForm = this.fb.group({
      id: [activityId],
      name: [activity?.name || '', [Validators.required, Validators.maxLength(100)]],
      description: [activity?.description || '', [Validators.required, Validators.maxLength(1000)]],
      results: [activity?.results || '', [Validators.required, Validators.maxLength(1000)]],
      startDate: [activity?.startDate || null, Validators.required],
      endDate: [activity?.endDate || null, Validators.required]
    });

    this.activitiesArray.push(activityForm);

     setTimeout(() => {
          if (!autoFocus) return;
    
          if (this.expansionPanels.length > 0) {
            const panel = this.expansionPanels.last;
            panel.open();
            setTimeout(() => {
              const lastInput = this.activityNameInputs.last?.nativeElement;
              lastInput?.focus();
            }, 50);
         }
      }, 50);
  }

  removeActivity(index: number): void {
    this.activitiesArray.removeAt(index);
    this.snackBar.open('Aktivnost uklonjena', 'Zatvori', {  
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top' });
  }

  closePanel(panel: MatExpansionPanel): void {
    panel.close();
  }
}